import { BaseClient } from '@/api'

export class GroupClient extends BaseClient {
  constructor(
  ) {
    super('groups')
  }
}
